package com.milta.core.localization.translations.en

import com.milta.core.localization.RouteCreationStrings

internal val RouteCreation = RouteCreationStrings(
    newRouteTitle = "New route",
    stepDeliveries = "Deliveries",
    stepDrivers = "Drivers",
    stepDistribution = "Distribution",
    deliveriesSummary = "%1 deliveries · %2 parcels",
    deliveriesSummaryOne = "1 delivery · %1 parcels",
    toFixCount = "%1 to fix",
    allAddressesCorrect = "All addresses are correct",
    filterAll = "All %1",
    filterToFix = "To fix %1",
    fixAddressesToContinue = "Fix %1 addresses to continue",
    fixOneAddressToContinue = "Fix 1 address to continue",
    continueWithDeliveries = "Continue · %1 deliveries",
    continueWithOneDelivery = "Continue · 1 delivery",
    chooseAtLeastOneDriver = "Choose at least one driver",
    reasonMissingHouseNumber = "Missing house number",
    reasonNotFound = "Address not found",
    reasonUnverified = "Could not be checked, try again",
    missingHouseNumberExample = "The house number is missing. Example: %1",
    notFoundHelp = "Address not found. Check the street, the number and the postcode.",
    unverifiedHelp = "The address could not be checked right now. Try again in a moment.",
    addToExistingHint = "They are added to the %1 deliveries already in the list.",
    importFileAction = "Import a file",
    importFileHint = "Excel (.xlsx, .xls), CSV or PDF",
    manualEntryAction = "Manual entry",
    manualEntryHint = "Name, address, phone, deadline",
    addDeliveryTitle = "Add a delivery",
    deleteDelivery = "Delete the delivery",
    addedFileAnalysing = "Analysing %1…",
    addedFileFailed = "The import of %1 did not complete. No delivery was added.",
    errorAddressesToFix = "Some addresses were not validated: fix them in the \"To fix\" list.",
    errorAddressesCheckRetry = "The address check did not complete. Try again in a moment.",
    errorBatchAlreadyDispatched = "This distribution has already been sent to the drivers.",
    editDeliveryTitle = "Edit the delivery",
    zoneLabel = "Zone %1",
    workloadBalanced = "Working times balanced between drivers",
    workloadGap = "Working time gap between drivers: %1",
    importAddedFromScan = "%1 deliveries added from the scan",
    importAddedOneFromScan = "1 delivery added from the scan",
    importAddedFromPdf = "%1 deliveries added from the PDF",
    importAddedOneFromPdf = "1 delivery added from the PDF",
    importAddedFromSpreadsheet = "%1 deliveries added from the Excel file",
    importAddedOneFromSpreadsheet = "1 delivery added from the Excel file",
    importAddedToFixSuffix = ", %1 to correct",
    deliverySearchOpenAction = "Search for a delivery",
    deliverySearchCount = "%1 of %2",
    deliverySearchCountToFix = "%1 of %2 to correct",
    deliverySearchEmptyTitle = "No matching delivery",
    deliverySearchEmptyToFixHint = "No delivery to correct matches. Try under “All”.",
)
